import type { TenantConfig } from '@/types/TenantConfig'

const blue = '#007CBA'
const green = '#6cc04a'

export const pnnm: TenantConfig = {
  logo: 'assets/pnnm/static/logo2.png',
  themeOptions: {
    primaryColor: blue,
    secondaryColor: blue,
    logoHeight: '77px',
    cartHeaderBackgroundColor: '#f8f8f8',
    cartHeaderTextColor: green,
    headerDropShadow: '0 4px 8px rgba(40, 43, 66, 0.1)',
    footerBackgroundColor: blue,
    footerTextColor: 'white',
    secondaryButtonStyle: 'solid',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,600;0,700;1,400;1,600;1,700&family=Sanchez:ital@0;1&display=swap',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/pnnm/static/completed-wide.jpg',
        mobile: 'assets/pnnm/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-150px',
      },
    },
  },
  i18nOverrides: {
    en: {
      homeRoute: {
        title: 'Log in, sign up or continue as a guest',
        loginTitle: 'Member Login',
        signupTitle: "I don't have a membership – Sign me up!",
        signupButton: 'Become a Member',
        guestTitle: 'Continue as a Guest',
        guestButton: 'Continue as a Guest',
      },
      loginForm: {
        loginButton: 'Continue',
        becomeAMember: "Don't have a membership? Become a member",
      },
      forgotMembership: {
        title: 'Access your digital membership card.',
      },
      membership: {
        title: 'Become a Member',
        renewTitle: 'Renew your Membership',
      },
      reserveDateFirst: {
        selectDateLabel: 'Choose a Date',
      },
      selectAvailableSession: {
        title: 'Choose a time',
      },
      selectTickets: {
        title: 'Choose tickets',
      },
      applyPromoCodes: {
        applyAnotherPromoCodeLabel: 'Add another discount code',
        applyPromoCodeLabel: 'Add discount code',
      },
      membershipLevel: {
        membershipLevel: 'Membership Levels',
      },
      namedMembers: {
        roleTitles: {
          member: 'Your name as you would like it to appear on your membership card',
        },
      },
      cartWidget: {
        percentFees: 'Service Charge',
      },
    },
  },
  customContent: [
    {
      key: 'member-benefits',
      regions: ['home-member-benefits'],
      template: `
        <div>
          <p>Membership allows you to experience all that the museum has to offer, at great value!</p>

          <ul>
              <li>Free general admission</li>
              <li>Reciprocal free admission to more than 300 museums around the world</li>
              <li>Discounts on paid events and programs</li>
          </ul>
        </div>
      `,
    },
    {
      key: 'guest-shopping',
      regions: ['home-guest-experience'],
      template: `
        <p>You can purchase tickets as a guest.</p>
      `,
    },
  ],
}
